const styles = (theme) => ({
  progress: {
    margin: theme.spacing(2),
  },
})
export default styles
